import { Link } from 'react-router'
import { CircleHelp } from 'lucide-react'

/** Tautan Bantuan di header; terlihat untuk semua user yang login, filternya di server. */
export function HelpHeaderLink({ to, testId }: { to: string; testId: string }) {
  return (
    <Link
      to={to}
      aria-label="Bantuan"
      className="inline-flex h-9 items-center gap-1.5 rounded-full px-2.5 text-sm text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100"
      data-testid={testId}
    >
      <CircleHelp size={18} />
      <span className="hidden md:inline">Bantuan</span>
    </Link>
  )
}
